import { useCallback } from 'react';
import cn from 'bem-cn';

import { CONDITIONS_URL, RoutePaths, RULES_COMPETE_URL_STORAGE_KEY } from '../../../constants';
import { useSessionStorageTransfer } from '../../../hooks';
import { Link } from '../../UI';

import type { ChallengeInfoRulesProps } from './ChallengeInfoRules.types';
import './ChallengeInfoRules.scss';

const b = cn('challenge-info-rules');

export const ChallengeInfoRules = (props: ChallengeInfoRulesProps) => {
    const { rulesUrl } = props;

    const { setValue: setRulesUrl } = useSessionStorageTransfer(RULES_COMPETE_URL_STORAGE_KEY);

    const handleRulesClick = useCallback(() => {
        if (rulesUrl) {
            setRulesUrl(rulesUrl);
        }
    }, [rulesUrl, setRulesUrl]);

    return (
        <p className={b()}>
            Нажимая кнопку «Принимаю челлендж!», я соглашаюсь с условиями участия в конкурсе{' '}
            <Link target="_blank" rel="noopener noreferrer" to={RoutePaths.CompeteRules} onClick={handleRulesClick}>
                «ИИ-челленджи на платформе Промптхаб»{' '}
            </Link>
            и принимаю{' '}
            <Link external to={CONDITIONS_URL}>
                условия использования сервиса
            </Link>
        </p>
    );
};
